import { render } from "./ManageDetails.vue?vue&type=template&id=f3c2db4a"
import script from "./ManageDetails.vue?vue&type=script&lang=js"
export * from "./ManageDetails.vue?vue&type=script&lang=js"

import "./ManageDetails.vue?vue&type=style&index=0&id=f3c2db4a&lang=css"

import exportComponent from "/home/runner/work/corpsales-services/corpsales-services/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__